/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextplacepromptlabel4Inputs */

const en_aitextplacepromptlabel4 = /** @type {(inputs: Aitextplacepromptlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What makes this place special?`)
};

const de_aitextplacepromptlabel4 = /** @type {(inputs: Aitextplacepromptlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was zeichnet diesen Ort aus?`)
};

/**
* | output |
* | --- |
* | "What makes this place special?" |
*
* @param {Aitextplacepromptlabel4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextplacepromptlabel4 = /** @type {((inputs?: Aitextplacepromptlabel4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextplacepromptlabel4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextplacepromptlabel4(inputs)
	return de_aitextplacepromptlabel4(inputs)
});
export { aitextplacepromptlabel4 as "aiTextPlacePromptLabel" }